import { passwordValidation } from 'BreetHelpers';
import * as yup from 'yup';

export const NewPasswordSchema = yup.object({
	oldPassword: yup.string().default(''),
	password: passwordValidation,
	confirmPassword: yup
		.string()
		.required('Confirm Password is required')
		.oneOf([yup.ref('password')], 'Passwords must match'),
});

export type NewPasswordSchemaType = yup.InferType<typeof NewPasswordSchema>;

export interface IFormNewPassword {
	onSuccess?: () => void;
	onRejected?: (reason: unknown) => void | PromiseLike<void>;
	type: 'change' | 'reset';
}
